import { Moment, Lodash } from '@intelipost-js/secure-providers';

import ScPslListTableAll from '../components/sc-psl-list-tables/ScPslListTableAll';
import ScPslFilterByAll from '../components/sc-psl-list-filters/ScPslFilterByAll';

export default {
  loading: false,
  sendPslLoading: false,
  filters: {
    searchBy: 'all',
    logisticProviderIds: [],
    localizedStatus: null,
    warehouseIds: [],
    dateRange: {
      start: Moment().subtract(1, 'days').format('YYYY-MM-DD'),
      end: Moment().endOf('day').format('YYYY-MM-DD'),
    },
  },
  searchMethod: {
    name: 'all',
    label: 'Todos',
    search: Lodash.cloneDeep(ScPslListTableAll),
    filter: Lodash.cloneDeep(ScPslFilterByAll),
  },
  psls: [],
  pslsCount: 0,
  volumesToSend: [],
  pagination: {
    page: 1,
    limit: 10,
  },
  AllVolumesSelected: false,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-psl/features/list/store/states.js